import { gql } from '@apollo/client';

export const GET_DEFAULT_TT_FROM_CODE = gql`
    query GetDefaultTtFromCode($warehouseId: Long!) {
        getDefaultTtFromCode(warehouseId: $warehouseId)
    }
`;

export interface GetDefaultTtFromCodeResponse {
    getDefaultTtFromCode: string | null;
}
